var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _circle, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _path, _g50, _g51;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRinkLtr = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 510",
    style: {
      enableBackground: "new 0 0 1200 510"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E43D30;}\n\t.st2{fill:#899199;}\n\t.st3{fill:#FFC629;}\n\t.st4{fill:#5B6670;}\n\t.st5{fill:#2F80ED;}\n\t.st6{fill:#EB5757;}\n\t.st7{fill:#B6E9FA;}\n\t.st8{fill:none;}\n\t.st9{fill:#333333;}\n\t.st10{fill:#B7B7B7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1199,371.5c0,75.9-61.7,137.5-137.8,137.5H138.8C62.7,509,1,447.5,1,371.5v-233C1,62.5,62.7,1,138.8,1h922.5 c76.1,0,137.8,61.5,137.8,137.5v233H1199z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M557,269.2c-0.5,0-0.8-0.4-0.8-0.8V261c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v7.4 C557.8,268.8,557.4,269.2,557,269.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M568.4,265.7c-0.5,0-0.8-0.4-0.8-0.8v-4.1c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v4.1 C569.2,265.4,568.9,265.7,568.4,265.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M568.4,276.2c-0.5,0-0.8-0.4-0.8-0.8v-4.1c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v4.1 C569.2,275.8,568.9,276.2,568.4,276.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M562.7,271.8c-0.5,0-0.8-0.4-0.8-0.8v-4.5c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v4.5 C563.5,271.4,563.1,271.8,562.7,271.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M562.7,264c-0.5,0-0.8-0.4-0.8-0.8V261c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v2.2 C563.5,263.6,563.1,264,562.7,264"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M562.7,258.6c-0.5,0-0.8-0.4-0.8-0.8v-2c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v2 C563.5,258.2,563.1,258.6,562.7,258.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M568.5,258.5c-0.5,0-0.8-0.4-0.8-0.8c0-2.7-2.2-5-5-5c-2.7,0-5,2.2-5,5c0,0.5-0.4,0.8-0.8,0.8 s-0.8-0.4-0.8-0.8c0-3.6,3-6.6,6.6-6.6s6.6,3,6.6,6.6C569.3,258.1,568.9,258.5,568.5,258.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M574.2,259.1c-0.5,0-0.8-0.4-0.8-0.8v-6.1c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v6.1 C575,258.7,574.6,259.1,574.2,259.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M574.2,276.2c-0.5,0-0.8-0.4-0.8-0.8v-2.6c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v2.6 C575,275.8,574.6,276.2,574.2,276.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M574.2,269.1h-5.8c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8h5.8c0.5,0,0.8,0.4,0.8,0.8 S574.7,269.1,574.2,269.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M547.5,234h3.8c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.4,0.8-0.8,0.8h-3.8c-0.5,0-0.8-0.4-0.8-0.8 C546.7,234.3,547.1,234,547.5,234"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M579.9,255.4c-0.5,0-0.8-0.4-0.8-0.8v-2.4c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v2.4 C580.7,255.1,580.4,255.4,579.9,255.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M579.9,260.8c-0.5,0-0.8-0.4-0.8-0.8v-2.4c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v2.4 C580.7,260.4,580.4,260.8,579.9,260.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M579.9,276.2c-0.5,0-0.8-0.4-0.8-0.8v-9.9c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v9.9 C580.7,275.8,580.4,276.2,579.9,276.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M551.3,248.8c0.5,0,0.8,0.4,0.8,0.8v2.5c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8v-2.5 C550.4,249.2,550.8,248.8,551.3,248.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M551.3,237c0.5,0,0.8,0.4,0.8,0.8v4c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8v-4 C550.4,237.4,550.8,237,551.3,237"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M539.8,237.5c0.5,0,0.8,0.4,0.8,0.8v3.6c0,0.5-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8v-3.6 C539,237.9,539.3,237.5,539.8,237.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M545.3,244.6h6c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.4,0.8-0.8,0.8h-6c-0.5,0-0.8-0.4-0.8-0.8 S544.9,244.6,545.3,244.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M560.5,274.5h4.4c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.4,0.8-0.8,0.8h-4.4c-0.5,0-0.8-0.4-0.8-0.8 C559.7,274.8,560,274.5,560.5,274.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M545.5,269.2c-0.5,0-0.8-0.4-0.8-0.8v-2.1c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v2.1 C546.4,268.9,546,269.2,545.5,269.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M545.5,276.2c-0.5,0-0.8-0.4-0.8-0.8v-3.3c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v3.3 C546.4,275.8,546,276.2,545.5,276.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M545.5,259.6c-0.5,0-0.8-0.4-0.8-0.8v-1.6c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v1.6 C546.4,259.3,546,259.6,545.5,259.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M545.5,254.3c-0.5,0-0.8-0.4-0.8-0.8v-5c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v5 C546.4,253.9,546,254.3,545.5,254.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M539.8,276.2c-0.5,0-0.8-0.4-0.8-0.8v-12.1c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v12.1 C540.6,275.8,540.2,276.2,539.8,276.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M539.8,258.3c-0.5,0-0.8-0.4-0.8-0.8v-12.2c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v12.2 C540.6,258,540.2,258.3,539.8,258.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M551.3,272.4c-0.5,0-0.8-0.4-0.8-0.8v-9.2c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v9.2 C552.1,272,551.7,272.4,551.3,272.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M551.3,258.7c-0.5,0-0.8-0.4-0.8-0.8v-2.8c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v2.8 C552.1,258.3,551.7,258.7,551.3,258.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M545.5,263.8c-2.1,0-3.7-1.7-3.7-3.7c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8c0,1.2,0.9,2.1,2.1,2.1 s2.1-0.9,2.1-2.1c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8C549.3,262.1,547.6,263.8,545.5,263.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M554.6,253h-3.4c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8h3.4c0.5,0,0.8,0.4,0.8,0.8 C555.4,252.6,555.1,253,554.6,253"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M553,276.1h-3.5c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8h3.5c0.5,0,0.8,0.4,0.8,0.8 S553.4,276.1,553,276.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M539.7,233.9c3.6,0,6.6,3,6.6,6.6v1.5c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8v-1.5c0-2.7-2.2-5-5-5 c-0.5,0-0.8-0.4-0.8-0.8C538.9,234.3,539.3,233.9,539.7,233.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M555,248.7c-0.1,0-0.2,0-0.3-0.1c-0.6-0.2-0.8-0.8-0.7-1.3l4.3-12.6c0.1-0.4,0.5-0.7,1-0.7h1 c0.5,0,0.9,0.3,1,0.7l4.1,12.6c0.2,0.6-0.1,1.1-0.7,1.3c-0.6,0.2-1.1-0.1-1.3-0.7l-3.6-11.2L556,248 C555.8,248.4,555.4,248.7,555,248.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M560.1,245h-2.2c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h2.2c0.6,0,1.1,0.5,1.1,1.1 C561.1,244.5,560.7,245,560.1,245"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M580,248.7c-0.6,0-1.1-0.5-1.1-1.1v-12.8c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1v12.8 C581.1,248.2,580.6,248.7,580,248.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M568.1,248.7c-0.6,0-1.1-0.5-1.1-1.1v-12.4c0-0.5,0.3-0.9,0.8-1c1.9-0.5,6.3-0.9,8,1.2 c1.8,2.3,1.6,5.9-0.4,7.7c-1.4,1.3-3.1,1.2-4.5,1c-0.6-0.1-1-0.6-0.9-1.2c0.1-0.6,0.6-1,1.2-0.9c1.5,0.2,2.1,0.1,2.7-0.5 c1.2-1.1,1.3-3.5,0.1-4.9c-0.6-0.7-2.9-1-5-0.6v11.6C569.2,248.2,568.7,248.7,568.1,248.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M557,276.2c-0.5,0-0.8-0.4-0.8-0.8v-2.1c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v2.1 C557.8,275.8,557.4,276.2,557,276.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M574.2,265.4c-0.5,0-0.8-0.4-0.8-0.8V262c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v2.6 C575,265,574.6,265.4,574.2,265.4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M637,269.3c-0.5,0-0.8-0.4-0.8-0.8v-7.4c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v7.4 C637.8,268.9,637.4,269.3,637,269.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M648.4,265.8c-0.5,0-0.8-0.4-0.8-0.8v-4.1c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v4.1 C649.2,265.5,648.9,265.8,648.4,265.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M648.4,276.3c-0.5,0-0.8-0.4-0.8-0.8v-4.1c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v4.1 C649.2,275.9,648.9,276.3,648.4,276.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M642.7,271.9c-0.5,0-0.8-0.4-0.8-0.8v-4.5c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v4.5 C643.5,271.5,643.1,271.9,642.7,271.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M642.7,264.1c-0.5,0-0.8-0.4-0.8-0.8v-2.2c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v2.2 C643.5,263.7,643.1,264.1,642.7,264.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M642.7,258.7c-0.5,0-0.8-0.4-0.8-0.8v-2c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v2 C643.5,258.3,643.1,258.7,642.7,258.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M648.5,258.6c-0.5,0-0.8-0.4-0.8-0.8c0-2.7-2.2-5-5-5c-2.7,0-5,2.2-5,5c0,0.5-0.4,0.8-0.8,0.8 s-0.8-0.4-0.8-0.8c0-3.6,3-6.6,6.6-6.6s6.6,3,6.6,6.6C649.3,258.2,648.9,258.6,648.5,258.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M654.2,259.2c-0.5,0-0.8-0.4-0.8-0.8v-6.1c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v6.1 C655,258.8,654.6,259.2,654.2,259.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M654.2,276.3c-0.5,0-0.8-0.4-0.8-0.8v-2.6c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v2.6 C655,275.9,654.6,276.3,654.2,276.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M654.2,269.2h-5.8c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8h5.8c0.5,0,0.8,0.4,0.8,0.8 S654.7,269.2,654.2,269.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M627.5,234.1h3.8c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.4,0.8-0.8,0.8h-3.8c-0.5,0-0.8-0.4-0.8-0.8 C626.7,234.4,627.1,234.1,627.5,234.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M659.9,255.5c-0.5,0-0.8-0.4-0.8-0.8v-2.4c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v2.4 C660.7,255.2,660.4,255.5,659.9,255.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M659.9,260.9c-0.5,0-0.8-0.4-0.8-0.8v-2.4c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v2.4 C660.7,260.5,660.4,260.9,659.9,260.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M659.9,276.3c-0.5,0-0.8-0.4-0.8-0.8v-9.9c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v9.9 C660.7,275.9,660.4,276.3,659.9,276.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M631.3,248.9c0.5,0,0.8,0.4,0.8,0.8v2.5c0,0.5-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8v-2.5 C630.4,249.3,630.8,248.9,631.3,248.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M631.3,237.1c0.5,0,0.8,0.4,0.8,0.8v4c0,0.5-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8v-4 C630.4,237.5,630.8,237.1,631.3,237.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.8,237.6c0.5,0,0.8,0.4,0.8,0.8v3.6c0,0.5-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8v-3.6 C619,238,619.3,237.6,619.8,237.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M625.4,244.7h6c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.4,0.8-0.8,0.8h-6c-0.5,0-0.8-0.4-0.8-0.8 C624.5,245.1,624.9,244.7,625.4,244.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M640.5,274.6h4.4c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.4,0.8-0.8,0.8h-4.4c-0.5,0-0.8-0.4-0.8-0.8 C639.7,274.9,640,274.6,640.5,274.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M625.5,269.3c-0.5,0-0.8-0.4-0.8-0.8v-2.1c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v2.1 C626.4,269,626,269.3,625.5,269.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M625.5,276.3c-0.5,0-0.8-0.4-0.8-0.8v-3.3c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v3.3 C626.4,275.9,626,276.3,625.5,276.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M625.5,259.7c-0.5,0-0.8-0.4-0.8-0.8v-1.6c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v1.6 C626.4,259.4,626,259.7,625.5,259.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M625.5,254.4c-0.5,0-0.8-0.4-0.8-0.8v-5c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v5 C626.4,254,626,254.4,625.5,254.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.8,276.3c-0.5,0-0.8-0.4-0.8-0.8v-12.1c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v12.1 C620.6,275.9,620.2,276.3,619.8,276.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.8,258.4c-0.5,0-0.8-0.4-0.8-0.8v-12.2c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v12.2 C620.6,258.1,620.2,258.4,619.8,258.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M631.3,272.5c-0.5,0-0.8-0.4-0.8-0.8v-9.2c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v9.2 C632.1,272.1,631.7,272.5,631.3,272.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M631.3,258.8c-0.5,0-0.8-0.4-0.8-0.8v-2.8c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v2.8 C632.1,258.4,631.7,258.8,631.3,258.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M625.5,263.9c-2.1,0-3.7-1.7-3.7-3.7c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8c0,1.2,0.9,2.1,2.1,2.1 s2.1-0.9,2.1-2.1c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8C629.3,262.2,627.6,263.9,625.5,263.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M634.6,253.1h-3.4c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8h3.4c0.5,0,0.8,0.4,0.8,0.8 C635.4,252.7,635.1,253.1,634.6,253.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M633,276.2h-3.5c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8h3.5c0.5,0,0.8,0.4,0.8,0.8 S633.4,276.2,633,276.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M619.7,234c3.6,0,6.6,3,6.6,6.6v1.5c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8v-1.5c0-2.7-2.2-5-5-5 c-0.5,0-0.8-0.4-0.8-0.8C618.9,234.4,619.3,234,619.7,234"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M635,248.8c-0.1,0-0.2,0-0.3-0.1c-0.6-0.2-0.8-0.8-0.7-1.3l4.3-12.6c0.1-0.4,0.5-0.7,1-0.7h1 c0.5,0,0.9,0.3,1,0.7l4.1,12.6c0.2,0.6-0.1,1.1-0.7,1.3c-0.6,0.2-1.1-0.1-1.3-0.7l-3.6-11.2l-3.8,11.3 C635.8,248.5,635.4,248.8,635,248.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M640.1,245.1h-2.2c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h2.2c0.6,0,1.1,0.5,1.1,1.1 C641.1,244.6,640.7,245.1,640.1,245.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M660,248.8c-0.6,0-1.1-0.5-1.1-1.1v-12.8c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1v12.8 C661.1,248.3,660.6,248.8,660,248.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M648.1,248.8c-0.6,0-1.1-0.5-1.1-1.1v-12.4c0-0.5,0.3-0.9,0.8-1c1.9-0.5,6.3-0.9,8,1.2 c1.8,2.3,1.6,5.9-0.4,7.7c-1.4,1.3-3.1,1.2-4.5,1c-0.6-0.1-1-0.6-0.9-1.2s0.6-1,1.2-0.9c1.5,0.2,2.1,0.1,2.7-0.5 c1.2-1.1,1.3-3.5,0.1-4.9c-0.6-0.7-2.9-1-5-0.6v11.6C649.2,248.3,648.7,248.8,648.1,248.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M637,276.3c-0.5,0-0.8-0.4-0.8-0.8v-2.1c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v2.1 C637.8,275.9,637.4,276.3,637,276.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M654.2,265.5c-0.5,0-0.8-0.4-0.8-0.8v-2.6c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v2.6 C655,265.1,654.6,265.5,654.2,265.5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Line_1_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447,
    className: "st5",
    width: 6,
    height: 510
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Line_2_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 747,
    className: "st5",
    width: 6,
    height: 510
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Line_4_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1132.5,21.8 1135.5,23.5 1135.5,487.1 1132.5,488.4  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Line_5_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "64.5,23.3 67.5,21.3 67.5,488.6 64.5,486.7  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6_7_",
    transform: "translate(1061 690)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -875,
    cy: -303,
    r: 90
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-875-213.2c-49.5,0-89.8-40.3-89.8-89.7s40.3-89.8,89.8-89.8s89.8,40.3,89.8,89.8S-825.5-213.2-875-213.2z  M-875-389.7c-47.8,0-86.8,38.9-86.8,86.8s38.9,86.8,86.8,86.8s86.8-38.9,86.8-86.8S-827.1-389.7-875-389.7z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7_7_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 186,
    cy: 387,
    r: 5.9
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4_7_",
    transform: "translate(110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_4_7_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "68.5,385.3 55.4,385.3 55.4,382.3 65.5,382.3 65.5,375.9 68.5,375.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_5_7_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "86.9,398.1 83.9,398.1 83.9,388.7 97.1,388.7 97.1,391.7 86.9,391.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6_7_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "97.1,385.3 83.9,385.3 83.9,375.9 86.9,375.9 86.9,382.3 97.1,382.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7_7_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "68.5,398.1 65.5,398.1 65.5,391.7 55.4,391.7 55.4,388.7 68.5,388.7  "
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6_6_",
    transform: "translate(1061 690)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -875,
    cy: -567,
    r: 90
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-875-477.2c-49.5,0-89.8-40.3-89.8-89.7s40.3-89.8,89.8-89.8s89.8,40.3,89.8,89.8S-825.5-477.2-875-477.2z  M-875-653.7c-47.8,0-86.8,38.9-86.8,86.8s38.9,86.8,86.8,86.8s86.8-38.9,86.8-86.8S-827.1-653.7-875-653.7z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7_6_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 186,
    cy: 123,
    r: 5.9
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_12_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 21.8,
    className: "st6",
    width: 3,
    height: 12
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4_6_",
    transform: "translate(110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_4_6_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "68.5,121.3 55.4,121.3 55.4,118.3 65.5,118.3 65.5,111.9 68.5,111.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_5_6_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "86.9,134.1 83.9,134.1 83.9,124.7 97.1,124.7 97.1,127.7 86.9,127.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6_6_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "97.1,121.3 83.9,121.3 83.9,111.9 86.9,111.9 86.9,118.3 97.1,118.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7_6_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "68.5,134.1 65.5,134.1 65.5,127.7 55.4,127.7 55.4,124.7 68.5,124.7  "
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6_5_",
    transform: "translate(1061 690)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -47.8,
    cy: -303,
    r: 90
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-47.8-213.2c-49.5,0-89.8-40.3-89.8-89.7s40.3-89.8,89.8-89.8S42-352.4,42-302.9S1.7-213.2-47.8-213.2z  M-47.8-389.7c-47.8,0-86.8,38.9-86.8,86.8s38.9,86.8,86.8,86.8S39-255,39-302.9S0-389.7-47.8-389.7z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7_5_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1013.2,
    cy: 387,
    r: 5.9
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4_5_",
    transform: "translate(110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_4_5_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "895.7,385.3 882.5,385.3 882.5,382.3 892.7,382.3 892.7,375.9 895.7,375.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_5_5_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "914,398.1 911,398.1 911,388.7 924.2,388.7 924.2,391.7 914,391.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6_5_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "924.2,385.3 911,385.3 911,375.9 914,375.9 914,382.3 924.2,382.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7_5_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "895.7,398.1 892.7,398.1 892.7,391.7 882.5,391.7 882.5,388.7 895.7,388.7  "
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 209.7794 752.4571)",
    className: "st0",
    cx: 1013.2,
    cy: 123,
    rx: 90,
    ry: 90
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1013.2,212.8c-49.5,0-89.8-40.3-89.8-89.7s40.3-89.8,89.8-89.8c49.5,0,89.7,40.3,89.7,89.8 S1062.7,212.8,1013.2,212.8z M1013.2,36.3c-47.8,0-86.8,38.9-86.8,86.8s38.9,86.8,86.8,86.8s86.7-38.9,86.7-86.8 S1061,36.3,1013.2,36.3z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1013.2,
    cy: 123,
    r: 5.9
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Path_4_4_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1005.7,121.3 992.5,121.3 992.5,118.3 1002.7,118.3 1002.7,111.9 1005.7,111.9  "
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Path_5_4_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1024,134.1 1021,134.1 1021,124.7 1034.2,124.7 1034.2,127.7 1024,127.7  "
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Path_6_4_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1034.2,121.3 1021,121.3 1021,111.9 1024,111.9 1024,118.3 1034.2,118.3  "
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Path_7_4_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1005.7,134.1 1002.7,134.1 1002.7,127.7 992.5,127.7 992.5,124.7 1005.7,124.7  "
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Path_8_1_",
    transform: "translate(1552 1038)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-419.1-760.1h-27.8c-0.4-1.2-1.2-3.7-2-6.9c-1-4.1-2.2-10.3-2.2-16.4c0-10,3.3-19.8,4.2-22.5h27.8V-760.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-446.1-804.7c-1.2,3.4-3.9,12.3-3.9,21.3c0,9.1,2.8,18.5,3.9,22.1h25.8v-43.4L-446.1-804.7 M-447.7-807h29.7 v48h-29.7c0,0-4.6-12.4-4.6-24.4S-447.7-807-447.7-807z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Path_9_1_",
    transform: "translate(947 1080) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M879.9,847.9h-27.8c-0.4-1.2-1.2-3.7-2-6.9c-1-4.1-2.2-10.3-2.2-16.4c0-10,3.3-19.8,4.2-22.5h27.8V847.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M852.9,803.3c-1.2,3.4-3.9,12.3-3.9,21.3c0,9.1,2.8,18.5,3.9,22.1h25.8v-43.4L852.9,803.3 M851.3,801H881v48 h-29.7c0,0-4.6-12.4-4.6-24.4S851.3,801,851.3,801z"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13_3_",
    transform: "translate(-866 -475.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_8_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 897.6,
    y: 642.1,
    transform: "matrix(0.247 -0.969 0.969 0.247 21.6557 1380.576)",
    className: "st6",
    width: 3,
    height: 68.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_9_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 864.9,
    y: 783.1,
    transform: "matrix(0.9688 -0.248 0.248 0.9688 -166.4906 247.5117)",
    className: "st6",
    width: 68.6,
    height: 3
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2_3_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 480,
    cy: 123,
    r: 6
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3_3_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 480,
    cy: 387,
    r: 6
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2_2_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 720,
    cy: 123,
    r: 6
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3_2_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 720,
    cy: 387,
    r: 6
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_1_",
    transform: "translate(331 132)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 269,
    cy: 123,
    r: 90
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M269,213c-49.6,0-90-40.4-90-90s40.4-90,90-90s90,40.4,90,90S318.6,213,269,213z M269,38.2 c-46.8,0-84.8,38-84.8,84.8s38,84.8,84.8,84.8s84.8-38,84.8-84.8S315.8,38.2,269,38.2z"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_9_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.5,
    y: 21.8,
    className: "st6",
    width: 3,
    height: 12
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_8_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 212.2,
    className: "st6",
    width: 3,
    height: 12
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_7_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.5,
    y: 212.2,
    className: "st6",
    width: 3,
    height: 12
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 237,
    className: "st6",
    width: 24,
    height: 36
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1134.6,
    y: 237,
    className: "st6",
    width: 24,
    height: 36
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13_2_",
    transform: "translate(-866 -475.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_8_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2031.3,
    y: 750.2,
    transform: "matrix(0.2471 -0.969 0.969 0.2471 770.2975 2560.4172)",
    className: "st6",
    width: 3,
    height: 68.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_9_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1998.4,
    y: 674.9,
    transform: "matrix(0.9692 -0.2462 0.2462 0.9692 -103.96 521.2712)",
    className: "st6",
    width: 68.6,
    height: 3
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M663.3,510h-6c0-31.6-25.7-57.3-57.3-57.3s-57.3,25.7-57.3,57.3h-6c0-34.9,28.4-63.3,63.3-63.3 C634.9,446.7,663.3,475.1,663.3,510z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_4_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1020.4,
    y: 21.8,
    className: "st6",
    width: 3,
    height: 12
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1002.4,
    y: 21.8,
    className: "st6",
    width: 3,
    height: 12
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1020.4,
    y: 212.2,
    className: "st6",
    width: 3,
    height: 12
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1002.4,
    y: 212.2,
    className: "st6",
    width: 3,
    height: 12
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_16_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 285.8,
    className: "st6",
    width: 3,
    height: 12
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_15_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.5,
    y: 285.8,
    className: "st6",
    width: 3,
    height: 12
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_14_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 476.2,
    className: "st6",
    width: 3,
    height: 12
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_13_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.5,
    y: 476.2,
    className: "st6",
    width: 3,
    height: 12
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_11_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1020.4,
    y: 285.8,
    className: "st6",
    width: 3,
    height: 12
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_10_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1002.4,
    y: 285.8,
    className: "st6",
    width: 3,
    height: 12
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_6_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1020.4,
    y: 476.2,
    className: "st6",
    width: 3,
    height: 12
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Line_7_5_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1002.4,
    y: 476.2,
    className: "st6",
    width: 3,
    height: 12
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Line_3_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597,
    className: "st6",
    width: 6,
    height: 510
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1062,4c35.8,0,69.4,13.9,94.8,39.2c25.3,25.3,39.2,59,39.2,94.8v234c0,35.8-13.9,69.4-39.2,94.8 c-25.3,25.3-59,39.2-94.8,39.2H138c-35.8,0-69.4-13.9-94.8-39.2C17.9,441.4,4,407.8,4,372V138c0-35.8,13.9-69.4,39.2-94.8 C68.6,17.9,102.2,4,138,4H1062 M1062,0H138C61.8,0,0,61.8,0,138v234c0,76.2,61.8,138,138,138h924c76.2,0,138-61.8,138-138V138 C1200,61.8,1138.2,0,1062,0L1062,0z"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M838.4,238h9.4l4.7,32.3h-7.8l-0.7-5.9h-10.3l-2.6,5.9h-7.7L838.4,238z M843.3,257.7l-1.3-13.2l-5.5,13.2 H843.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M864.4,244.7H856l1.1-6.7h24.3l-1.1,6.7h-8.4l-4,25.6h-7.5L864.4,244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M891.4,244.7H883l1.1-6.7h24.3l-1.1,6.7h-8.4l-4,25.6h-7.5L891.4,244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M918.3,238h9.4l4.7,32.3h-7.8l-0.7-5.9h-10.3l-2.6,5.9h-7.7L918.3,238z M923.2,257.7l-1.3-13.2l-5.5,13.2 H923.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M939.3,267.6c-1.8-2-2.7-4.7-2.7-8.3c0-2,0.2-4.1,0.5-6.3c0.8-5.2,2.3-9.1,4.4-11.6c2.1-2.5,5.3-3.7,9.4-3.7 c4.1,0,7.6,0.7,10.6,2l-1,6c-1.2-0.4-2.6-0.7-4.1-0.9c-1.5-0.2-2.9-0.3-4.2-0.3c-1.5,0-2.7,0.2-3.7,0.7c-0.9,0.5-1.7,1.4-2.4,2.8 c-0.7,1.4-1.2,3.5-1.7,6.4c-0.3,2.3-0.5,4-0.5,5.1c0,1.6,0.4,2.7,1.2,3.4s2.3,1,4.3,1c1.7,0,3.1,0,4.2-0.1c1.1-0.1,2.5-0.2,4-0.4 l-0.9,5.9c-2.4,0.9-5.5,1.4-9.3,1.4C943.9,270.5,941.1,269.6,939.3,267.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M966.1,238h7.5l-2,12.7h3.7l8.2-12.7h7.7l-10.3,16.2l6,16.1h-7.4l-4.7-12.8h-4.2l-2,12.8h-7.5L966.1,238z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M994.7,238h7.5l-5.1,32.3h-7.5L994.7,238z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1007.3,238h6l9.3,19.6l3.1-19.6h7.5l-5.1,32.3h-6l-9.3-19.6l-3.1,19.6h-7.5L1007.3,238z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1035.9,268.1c-1.3-1.6-1.9-4.2-1.9-7.8c0-1.8,0.3-4.4,0.8-7.7c0.8-5,2.4-8.8,4.7-11.2 c2.4-2.5,5.5-3.7,9.5-3.7c2.6,0,4.7,0.1,6.4,0.4c1.7,0.3,3.4,0.6,4.9,1.1l-0.9,5.9c-2.6-0.5-5.7-0.7-9.4-0.7 c-1.8,0-3.2,0.3-4.1,0.9c-1,0.6-1.7,1.6-2.3,3c-0.5,1.4-1,3.4-1.4,5.9c-0.3,2.3-0.5,4-0.5,5.4s0.3,2.3,0.8,3c0.6,0.7,1.4,1,2.6,1 c1,0,2-0.1,3.2-0.2c1.2-0.1,2.1-0.3,2.6-0.5l0.8-5.2h-5.1l1-5.9l0.9-0.1c2.7-0.2,4.8-0.3,6.3-0.3c2.1,0,3.8,0,5.1,0.1l-3,18.8h-5.7 l-0.7-2.2c-0.9,0.6-2.2,1.1-3.9,1.6s-3.1,0.8-4.3,0.8C1039.3,270.5,1037.2,269.7,1035.9,268.1z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M143.2,238h12.5c4.2,0,7,1,8.7,2.9c1.6,1.9,2.5,4.7,2.5,8.4c0,2.1-0.2,4-0.5,6c-0.6,3.6-1.5,6.5-2.9,8.7 c-1.3,2.2-3.1,3.8-5.2,4.8c-2.1,1-4.8,1.5-7.9,1.5h-12.3L143.2,238z M151.1,263.5c2.2,0,3.9-0.8,5.1-2.3c1.2-1.5,2-3.9,2.6-7.2 c0.3-2.1,0.5-3.5,0.5-4.4c0-1.8-0.4-3.1-1.3-3.8s-2.2-1.1-4.2-1.1h-4.1l-3,18.8H151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M171.4,269.3c-1.5-0.9-2.2-2.4-2.2-4.6c0-0.5,0-1.1,0.1-1.6l2.7-17.2c0.8-5.2,3.8-7.8,9.1-7.8 c4,0,8.4,0.2,13.2,0.6l-1,6.4h-11.1c-0.9,0-1.6,0.2-2.1,0.7c-0.5,0.4-0.7,1.1-0.9,2.1l-0.5,3l11.3,0.4l-0.9,6l-11.5,0.4l-0.5,3.4 c0,0.1,0,0.4,0,0.7c0,1.3,0.8,1.9,2.3,1.9h10.9l-1,6.3c-5.1,0.5-9.4,0.7-13,0.7C174.5,270.5,172.8,270.1,171.4,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M197.8,245.6c0.4-2.8,1.5-4.8,3.1-5.9c1.6-1.1,3.6-1.7,5.8-1.7c4.6,0,9,0.2,13.2,0.7l-1,6.4h-11 c-1,0-1.7,0.2-2.1,0.7c-0.4,0.4-0.7,1.1-0.9,2l-0.7,4.3l11.4,0.3l-1,6l-11.5,0.4l-1.9,11.7h-7.5L197.8,245.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M221.4,269.3c-1.5-0.9-2.2-2.4-2.2-4.6c0-0.5,0-1.1,0.1-1.6l2.7-17.2c0.8-5.2,3.8-7.8,9.1-7.8 c4,0,8.4,0.2,13.2,0.6l-1,6.4h-11.1c-0.9,0-1.6,0.2-2.1,0.7c-0.5,0.4-0.7,1.1-0.9,2.1l-0.5,3l11.3,0.4l-0.9,6l-11.5,0.4l-0.5,3.4 c0,0.1,0,0.4,0,0.7c0,1.3,0.8,1.9,2.3,1.9h10.9l-1,6.3c-5.1,0.5-9.4,0.7-13,0.7C224.5,270.5,222.8,270.1,221.4,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M249.4,238h6l9.3,19.6l3.1-19.6h7.5l-5.1,32.3h-6l-9.3-19.6l-3.1,19.6h-7.5L249.4,238z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M280,238h12.5c4.2,0,7,1,8.7,2.9c1.6,1.9,2.5,4.7,2.5,8.4c0,2.1-0.2,4-0.5,6c-0.6,3.6-1.5,6.5-2.9,8.7 c-1.3,2.2-3.1,3.8-5.2,4.8c-2.1,1-4.8,1.5-7.9,1.5h-12.3L280,238z M287.9,263.5c2.2,0,3.9-0.8,5.1-2.3c1.2-1.5,2-3.9,2.6-7.2 c0.3-2.1,0.5-3.5,0.5-4.4c0-1.8-0.4-3.1-1.3-3.8s-2.2-1.1-4.2-1.1h-4.1l-3,18.8H287.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M310.1,238h7.5l-5.1,32.3H305L310.1,238z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M322.7,238h6l9.3,19.6L341,238h7.5l-5.1,32.3h-6l-9.3-19.6l-3.1,19.6h-7.5L322.7,238z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M351.3,268.1c-1.3-1.6-1.9-4.2-1.9-7.8c0-1.8,0.3-4.4,0.8-7.7c0.8-5,2.4-8.8,4.7-11.2 c2.4-2.5,5.5-3.7,9.5-3.7c2.6,0,4.7,0.1,6.4,0.4c1.7,0.3,3.4,0.6,4.9,1.1l-0.9,5.9c-2.6-0.5-5.7-0.7-9.4-0.7 c-1.8,0-3.2,0.3-4.1,0.9c-1,0.6-1.7,1.6-2.3,3c-0.5,1.4-1,3.4-1.4,5.9c-0.3,2.3-0.5,4-0.5,5.4s0.3,2.3,0.8,3c0.6,0.7,1.4,1,2.6,1 c1,0,2-0.1,3.2-0.2c1.2-0.1,2.1-0.3,2.6-0.5l0.8-5.2H362l1-5.9l0.9-0.1c2.7-0.2,4.8-0.3,6.3-0.3c2.1,0,3.8,0,5.1,0.1l-3,18.8h-5.7 l-0.7-2.2c-0.9,0.6-2.2,1.1-3.9,1.6s-3.1,0.8-4.3,0.8C354.7,270.5,352.6,269.7,351.3,268.1z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRinkLtr, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rink-ltr.c124d3a3.svg";
export { ForwardRef as ReactComponent };